module.exports = __webpack_public_path__ + "img/contact-background.be8bc53a.jpg";